import { render, staticRenderFns } from "./SubRegistro.vue?vue&type=template&id=35f03002&scoped=true&"
import script from "./SubRegistro.vue?vue&type=script&lang=js&"
export * from "./SubRegistro.vue?vue&type=script&lang=js&"
import style0 from "./SubRegistro.vue?vue&type=style&index=0&id=35f03002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f03002",
  null
  
)

export default component.exports